import { Component } from '@angular/core';

@Component({
  selector: 'app-admission-sghsc',
  templateUrl: './admission-sghsc.component.html',
  styleUrls: ['./admission-sghsc.component.scss']
})
export class AdmissionSghscComponent {

}
